import { Box } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { styles } from './styles/setting-item-styles';

type SettingItemProps = {
  title: string;
  description?: string;
  actionSlot?: React.ReactNode;
};

export const SettingItem = ({
  actionSlot,
  description,
  title,
}: SettingItemProps) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.textContainer}>
        <CustomTypography
          variant="body1"
          sx={{
            fontSize: '18px',
            color: (theme) => theme.palette.custom.black[90],
            mb: 0.05,
            fontWeight: 500,
            style: 'medium',
          }}
        >
          {title}
        </CustomTypography>
        <CustomTypography
          variant="body2"
          sx={{
            fontSize: '14px',
            color: (theme) => theme.palette.custom.black[30],
            fontWeight: 500,
            style: 'medium',
          }}
        >
          {description}
        </CustomTypography>
      </Box>
      {actionSlot}
    </Box>
  );
};
